import Filter from '@pages/list/Filter.vue'
import Promoted from '@pages/list/Promoted.vue'
import Products from '@pages/list/Products.vue'
import Endpoints from '@commons/communication/endpoints.js'
import { mapGetters } from 'vuex'


export default{
    components:{
        FilterView:Filter,
        Promoted,
        Products
    },
    mixins:[Endpoints],
    data:function(){
        return {
            result:{},
            baseUrl: '',
            lastFilter: {},
            lastQuery: null,
            page:1,
            noMorePage: false,
            loading: false,
        };
    },
    computed: {
        query:function () {
            return this.$store.getters.getSearchQuery;
        }
    },
    watch:{
        query:function (q) {
            this.searchChanged(q);
        }
    },
    created:function () {
        this.baseUrl = window.location;
        this.refreshData(this.$route.query.filter);

        var self = this;
        // window.onscroll = function() {
        //   var d = document.documentElement;
        //   var offset = (window.pageYOffset || d.scrollTop) + window.innerHeight;
        //   var height = d.offsetHeight;
        //
        //   if ((offset+80) >= height) {
        //     self.loadNextPage()
        //   }
        // };
    },
    beforeDestroy:function () {
        window.onscroll = null;
    },
    methods:{
        refreshData:function (state,search = {}, query = null) {
            this.page = 1;
            this.noMorePage = false;
            var o = {}

            if (state != null){
                o = JSON.parse(atob(state));
                this.lastFilter = o;
                this.lastQuery = o.search;
                this.$store.commit('setSearchQuery',o.search);
            }else{
                o = search;
                o.search = query;
            }

            var self = this;
            this.loading = true;
            this.connFilterProducts(o,function (r) {
                self.result = r.data;
                self.loading =false;
                console.log(self.result);
            });

            window.history.replaceState(null, window.title, 'list?filter='+btoa(JSON.stringify(o)));

        },
        filterChanged:function (search) {
            $.extend(this.lastFilter, search);
            if (!search.propertyGroups || search.propertyGroups.length ==0){
                this.lastFilter.propertyGroups = null;
            }

            this.refreshData(null,this.lastFilter,this.lastQuery);
        },
        searchChanged:function (query) {
            this.lastQuery = query;
            this.refreshData(null,this.lastFilter,query);
        },
        loadNextPage:function () {
            if (!this.result.uuid) return;
            if (this.loading) return;
            if (this.noMorePage) return;

            this.page++;
            var o = {
                uuid: this.result.uuid,
                page: this.page
            }

            var self = this;
            this.loading = true;
            this.connFilterProducts(o,function (r) {
                console.log("next page loaded");
                if (r.data.products.list.length == 0) self.noMorePage = true;

                self.result.products.list = self.result.products.list.concat(r.data.products.list);
                self.$nextTick(function () {
                    self.loading = false;
                })
            });
        }

    }
}



// WEBPACK FOOTER //
// ./src/app/main/components/pages/list/ListPage.js